export default "__VITE_ASSET__Rqn$jbmU__"